import React from 'react'

import { QuantityBadge } from '@components/common/QuantityBadge'
import { Icon } from '@fourthwall/components'
import { PhotoIcon } from '@fourthwall/icons'

import * as S from './styled'
import type { ImagePreviewProps } from './types'

export const OfferPreview = ({ image, imagesCount }: ImagePreviewProps) => (
  <S.Container>
    {image ? (
      <S.Image src={image} />
    ) : (
      <S.PreviewIcon>
        <Icon component={PhotoIcon} height={24} />
      </S.PreviewIcon>
    )}
    {imagesCount && imagesCount > 1 && <QuantityBadge quantity={imagesCount} />}
  </S.Container>
)
